import { render, staticRenderFns } from "./EduRecords.vue?vue&type=template&id=5cc1323d&scoped=true"
import script from "./EduRecords.vue?vue&type=script&lang=js"
export * from "./EduRecords.vue?vue&type=script&lang=js"
import style0 from "./EduRecords.vue?vue&type=style&index=0&id=5cc1323d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc1323d",
  null
  
)

export default component.exports